'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _sweetalertReact = require('sweetalert-react');

var _sweetalertReact2 = _interopRequireDefault(_sweetalertReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    sweetalert: typeof state.toJS === 'function' ? state.toJS().sweetalert : state.sweetalert
  };
};

var ReduxSweetAlert = function (_Component) {
  _inherits(ReduxSweetAlert, _Component);

  function ReduxSweetAlert() {
    _classCallCheck(this, ReduxSweetAlert);

    return _possibleConstructorReturn(this, (ReduxSweetAlert.__proto__ || Object.getPrototypeOf(ReduxSweetAlert)).apply(this, arguments));
  }

  _createClass(ReduxSweetAlert, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_sweetalertReact2.default, this.props.sweetalert);
    }
  }]);

  return ReduxSweetAlert;
}(_react.Component);

ReduxSweetAlert.propTypes = {
  sweetalert: _react.PropTypes.shape({
    show: _react.PropTypes.bool.isRequired,
    title: _react.PropTypes.string.isRequired
  }).isRequired
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReduxSweetAlert);


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/lib/ReduxSweetAlert.js
// module id = ./node_modules/react-redux-sweetalert/lib/ReduxSweetAlert.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons